module.exports = __webpack_public_path__ + "static/img/MADRID_OAK.0124fb4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/MADRID_OAK.jpg
// module id = 6hsq
// module chunks = 0